import { memo } from 'react';
import DocumentBrowser from '../../components/DocumentStore/DocumentBrowser/DocumentBrowser';
import FullScreen from '../../components/Common/FullScreen/FullScreen';
import Container from '../../components/Common/Container/Container';
import { Spacing } from '../../types/appTypes';
import css from './DocumentStorePage.module.css';

const DocumentTitle = memo(() => (
  <h1 className={css.title}>Documents</h1>
));

const DocumentsPage = () => {
  return (
    <FullScreen background="color">
      <Container margin={[Spacing.Auto]} secondaryClass={css.container}>
        <DocumentTitle />
        <DocumentBrowser />
      </Container>
    </FullScreen>
  );
};

export default DocumentsPage;